import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addCTA: 'Add',
    addEmail: 'Add email',
    cancel: 'Cancel',
    descriptionAllComplete:
      'All beneficial owners have completed their information. Ready to be reviewed.',
    descriptionWaiting:
      'We will only be able to verify your application once all beneficial owners have completed their information.',
    directorDescription:
      'They legally represent the company or have a mandate as Président or Gérant.',
    directorLabel: 'Are they a director of the company?',
    editEmail: 'Edit email',
    goToHome: 'Back to my application',
    inputEmailLabel: 'Email address',
    invalidMessage:
      'If they are neither a director nor a shareholder of at least 25% of the company’s shares, this means that they are not one of the beneficial owners. Please check your answers, or delete this person.',
    invite: 'Send invitation',
    inviteeEmail: 'Email Address',
    linkCopySuccess: 'Link copied in the clipboard.',
    linkResendInvitationSuccess: 'Invitation successfully sent to {name}!',
    majorShareholderDescription:
      'It is a shareholder of 25% or more of the company’s shares, directly or not.',
    majorShareholderLabel: 'Do they have 25% or more of the company’s shares?',
    newBeneficiaryCardTitle: 'New beneficial owner',
    no: 'No',
    remind: 'Remind',
    resend: 'Resend invitation',
    save: 'Save',
    saveNewBeneficiary: 'Save',
    send: 'Resend invitation',
    sent: 'Email sent!',
    share: 'Copy Link',
    statusEmailMissing: 'Email missing',
    statusInProgress: 'In progress',
    statusInReview: 'Profile completed',
    statusInvalid: 'Invalid',
    statusNotStarted: 'Not Started',
    statusRefused: 'Refused',
    statusRejected: 'Rejected',
    statusValidated: 'Complete',
    subTitle: 'Beneficial owners',
    title: 'Follow their progress',
    yes: 'Yes',
  },
  fr: {
    addCTA: 'Ajouter',
    addEmail: 'Ajouter l’e-mail',
    cancel: 'Annuler',
    descriptionAllComplete:
      'Tous les bénéficiaires effectifs ont renseigné leurs informations. Votre dossier est prêt à être vérifié\u00A0!',
    descriptionWaiting:
      'Nous ne pourrons vérifier le dossier de votre entreprise qu’une fois que tous les bénéficiaires effectifs auront complété leurs informations.',
    directorDescription:
      'Représente légalement l’entreprise ou dispose d’un mandat de président ou gérant.',
    directorLabel: 'Est-il·elle un·e dirigeant·e de l’entreprise\u00A0?',
    editEmail: 'Éditer l’adresse e-mail',
    goToHome: 'Retourner sur mon dossier',
    inputEmailLabel: 'Adresse e-mail',
    invalidMessage:
      'Si cette personne n’est ni dirigeante ni actionnaire d’au moins 25\u00A0% des parts de l’entreprise le·la signifie qu’elle ne fait pas partie des bénéficiaires effectifs. Veuillez vérifier vos réponses, ou supprimer cette personne.',
    invite: 'Envoyer l’invitation',
    inviteeEmail: 'Adresse e-mail',
    linkCopySuccess: 'Lien copié dans le presse-papier',
    linkResendInvitationSuccess: 'Invitation bien envoyée à {name}!',
    majorShareholderDescription:
      'Il·Elle est actionnaire à hauteur de 25\u00A0% ou plus des parts de l’entreprise, directement ou non.',
    majorShareholderLabel:
      'A-t-il·elle 25\u00A0% ou plus des parts de l’entreprise\u00A0?',
    newBeneficiaryCardTitle: 'Nouveau bénéficiaire',
    no: 'Non',
    remind: 'Envoyer un rappel',
    resend: 'Renvoyer l’invitation',
    save: 'Enregistrer',
    saveNewBeneficiary: 'Enregistrer',
    send: 'Renvoyer l’invitation',
    sent: 'E-mail envoyé\u00A0!',
    share: 'Copier le lien',
    statusEmailMissing: 'Email manquant',
    statusInProgress: 'En cours',
    statusInReview: 'Dossier complété',
    statusInvalid: 'Invalide',
    statusNotStarted: 'En attente',
    statusRefused: 'Refusé',
    statusRejected: 'Invalide',
    statusValidated: 'Complet',
    subTitle: 'Bénéficiaires effectifs',
    title: 'Suivre la progression',
    yes: 'Oui',
  },
} as const);
